import { loadingContext } from "@/app/store/context/isLoadingContext"
import { screenSizeContext } from "@/app/store/context/screenSizesContext"
import NextLink from "next/link"
import { usePathname, useSearchParams, useRouter } from "next/navigation"
import { useContext } from "react"
const Link = ({ href, excludeParams, children, ...props }: any) => {
	const searchParams = useSearchParams()
  const {setIsPageFetched} = useContext(loadingContext)
  const pathname = usePathname()
	const router = useRouter();
	const { isIpad } = useContext(screenSizeContext);

	const handleNavigation = (e: any) => {
    e.preventDefault();
    const normalizedTarget = `${href}`.replace(/\/+$/, '') || '/';
    const normalizedPathname = pathname.replace(/\/+$/, '') || '/';

    if (normalizedTarget !== normalizedPathname) {
			if(!isIpad) window.lenis?.stopScroll?.(true);
			else document.documentElement.style.overflow = "hidden";
      setIsPageFetched("loading");
      setTimeout(() => router.push(href), 1700);
    }
  }

	return (
		<NextLink
			// onClick={() => pathname != href && setIsPageFetched("loading")}
			onClick={handleNavigation}
			href={{
				pathname: href,
				query: excludeParams ? "" : Object.fromEntries(searchParams.entries()),
			}}
			{...props}
		>
			{children}
		</NextLink>
	);
}

export default Link
